import React from 'react'

import { Card, Row, Col, List } from 'antd'

class CartDetails extends React.Component{

    render(){
        return(
            <Card
                title="Cart Details"
                style={{height:800}}>
                <Row>
                    
                    <Card
                        title="Products in cart"
                        type="inner"
                        style={{marginBottom:20}}>                          
                        {this.props.cartdetails.products.length<1?
                            "No products in cart":
                            this.renderProductsInCart(this.props.cartdetails.products)
                        }
                    </Card>
                    <Card
                        title="Products removed from cart"
                        type="inner">
                        {this.props.cartdetails.removedProducts?
                            this.props.cartdetails.removedProducts.length<1?
                                "No products removed from cart":
                                    this.renderProductsInCart(this.props.cartdetails.removedProducts):
                            "No removed cart"
                        }
                    </Card>
            
                </Row>
            </Card>
        )
    }

    renderProductsInCart=(products)=>{

        return(
            <List
                style={{maxHeight:350, overflowY:"auto", overflowX: "hidden"}}>
                {products.map((product)=>{

                    const { title, images, categories } = product.product

                    return(
                        <List.Item>
                            <Row gutter={12}
                                 style={{width:"100%"}}>
                                <Col span={8}
                                     style={{textAlign:"center"}}>
                                    <img 
                                        alt="product"
                                        style={{maxHeight:60, maxWidth:60}}
                                        src={images[0].url}/>
                                </Col>
                                <Col span={16}>
                                    <div>
                                        <div
                                            style={{fontSize:12, fontWeight:700}}>
                                            {title}
                                        </div>
                                        <hr/>
                                        <div
                                            style={{fontSize:10}}>
                                            {categories.main}
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </List.Item>
                    )
                })}
            </List>
        )
    }
}

export default CartDetails


// WEBPACK FOOTER //
// ./src/components/customer-journey/cart-details.js